import React, { useState } from 'react';
import { useParams } from 'react-router';
import { observer } from 'mobx-react';

import usePublicApi from 'public-api';
import { getErrors } from 'public-api/utils';
import { useAsyncFunction } from 'stores/hooks';
import { Button, Form } from 'ui';

type RouteParams = {
  invitationId: string;
};

function Invitation() {
  const { invitationId } = useParams<RouteParams>();

  const [errors, setErrors] = useState({});

  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');

  const publicApi = usePublicApi();

  const send = async () => {
    setErrors({});
    const data = {
      full_name: name,
      password,
      password2,
    };
    try {
      await publicApi.AuthAcceptInvitationApi.create({ id: invitationId!, request: data });
      window.location.replace('/');
    } catch (error) {
      const response = await getErrors(error);
      setErrors(response);
    }
  };

  const [handleSend, isSending] = useAsyncFunction(send);

  return (
    <>
      <h2 className="text-center text-xl font-medium text-gray-900">{gettext('Accept invitation')}</h2>
      <p className="mt-3 text-center text-sm text-gray-500">
        {gettext(
          'You were invited to join your team at Retino. Please enter your name and choose your new password. You will use this password, together with your email, to log into Retino.',
        )}
      </p>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="space-y-6">
            <div>
              <Form.Input
                required
                autoFocus
                name="fullname"
                value={name}
                label={gettext('Your name')}
                onChange={setName}
                error={errors.full_name}
              />
            </div>
            <div>
              <Form.Input
                required
                name="password1"
                type="password"
                value={password}
                label={gettext('Password')}
                helpText={gettext('At least 8 characters')}
                onChange={setPassword}
                error={errors.password}
              />
            </div>
            <div>
              <Form.Input
                required
                name="password2"
                type="password"
                value={password2}
                label={gettext('Password again')}
                onChange={setPassword2}
                error={errors.password2}
              />
            </div>
            <div>
              <Button submit primary fluid loading={isSending} onClick={handleSend}>
                {gettext('Join team')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default observer(Invitation);
